import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { exchangeOAuthCode } from '../services/auth';
import { useAuth } from '../hooks/useAuth';
import Loading from '../components/common/Loading';

function OauthCodeExchangePage() {
  const navigate = useNavigate();
  const { setUser, user } = useAuth();
  const [searchParams] = useSearchParams();
  console.log('[OauthCodeExchangePage] Search params:', searchParams);
  const code = searchParams.get('code');
  const [isProcessing, setIsProcessing] = useState(true);

  console.log('[OauthCodeExchangePage] Initial render, code:', code, 'user:', user);
  
  useEffect(() => {
    console.log('[OauthCodeExchangePage] First useEffect triggered, code:', code);
    
    const fetchUser = async () => {
      console.log('[OauthCodeExchangePage] Fetching user with code');
      try {
        const userData = await exchangeOAuthCode(code as string);
        console.log('[OauthCodeExchangePage] User data received:', userData);
        setUser(userData);
        console.log('[OauthCodeExchangePage] Setting isProcessing to false');
        setIsProcessing(false);
      } catch (error) {
        console.error('[OauthCodeExchangePage] Error exchanging OAuth code:', error);
        navigate('/login');
      }
    };
    
    if (code) {
      fetchUser();
    } else {
      console.log('[OauthCodeExchangePage] No code provided, redirecting to login');
      navigate('/login');
    }
  }, [code, setUser, navigate]);

  // Second effect to handle navigation after user is set
  useEffect(() => {
    console.log('[OauthCodeExchangePage] Second useEffect triggered, isProcessing:', isProcessing, 'user:', user);
    
    if (!isProcessing && user) {
      console.log('[OauthCodeExchangePage] Conditions met, navigating to /projects');
      navigate('/projects');
    }
  }, [isProcessing, user, navigate]);

  console.log('[OauthCodeExchangePage] Rendering loading component');
  return <Loading />;
}

export default OauthCodeExchangePage;
